// extracted by mini-css-extract-plugin
export default {"navLink":"NavigationLink_navLink__kfrff","active":"NavigationLink_active__tnc1X"};